import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CartFormService } from '../cart-form.service';
import { CartService } from '../cart.service';

@Component({
  selector: 'app-cart-proceed-to-checkout',
  templateUrl: './cart-proceed-to-checkout.component.html',
  styleUrls: ['./cart-proceed-to-checkout.component.scss']
})
export class CartProceedToCheckoutComponent implements OnInit {
  public cartValidationInProgress: boolean = false;
  form: FormGroup = this.cartFormService.form;
  invalidFormData: boolean = true;
  invalidQuantity: boolean = false;

  @Input() enableDisableBtn: boolean = false;
  @Output() onContinueEventEmitter = new EventEmitter<string>();
  constructor(private cartService: CartService,
    private cartFormService: CartFormService,
    protected cd: ChangeDetectorRef) {
    this.invalidFormData = this.form?.value?.ponumber !== '' ? false : true;
    this.cartService.onButtonEnableDisable.subscribe((isDisable: boolean) => {
      this.invalidQuantity = isDisable;
    })

  }

  ngOnInit(): void {
    this.form.valueChanges.subscribe(data => {
      this.invalidFormData = data?.ponumber !== '' && data?.nominatedDays !== '' ? false : true;
      if (data?.nominatedDays !== '' && this.invalidFormData === false) {
        this.invalidQuantity = false;
      }
      this.cd.detectChanges();
    })

  }

  onContinueBtnClick() {
    if (this.invalidFormData) return;
    this.cartService.onContinueBtnClick.next(true);
  }

}
